import React from "react";
import { Link } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { useContent } from "../contexts/SiteContentContext";

// LockedHeader: minimal, non-clickable brand strip used during post-checkout
// guest signup. NO navigation links — user must create a password first.
function LockedHeader() {
  const g = useContent("global");
  return (
    <header
      data-testid="locked-header"
      className="sticky top-0 z-50 backdrop-blur-xl bg-ink-50/80 border-b border-white/10"
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-5 flex items-center justify-between">
        <div data-testid="locked-brand" className="flex items-center gap-3 select-none pointer-events-none">
          <img
            src={g.logo_url || "https://customer-assets.emergentagent.com/job_dossier-mystery/artifacts/13m4sz09_956183d9-214d-4237-bfe0-325064ecc672.png"}
            alt={g.brand_full || "Crimes em Casa"}
            className="h-12 md:h-14 w-auto object-contain"
          />
          <span className="mono text-[10px] text-bone-muted hidden md:inline ml-1 tracking-[0.3em] border-l border-white/15 pl-3">
            // DOSSIER
          </span>
        </div>
        <span
          data-testid="locked-status-pill"
          className="mono text-[10px] tracking-[0.3em] text-blood border border-blood/40 px-3 py-1.5"
        >
          ACESSO PENDENTE
        </span>
      </div>
    </header>
  );
}

export default function Layout({ children, noFooter = false, locked = false }) {
  return (
    <div className="relative min-h-screen bg-ink-50 text-white">
      <div className="grain-overlay" aria-hidden />
      {locked ? <LockedHeader /> : <Navbar />}
      <main>{children}</main>
      {locked || noFooter ? null : <Footer />}
    </div>
  );
}
